import { render, staticRenderFns } from "./modal-add-product.vue?vue&type=template&id=6e23c989"
import script from "./modal-add-product.vue?vue&type=script&lang=js"
export * from "./modal-add-product.vue?vue&type=script&lang=js"
import style0 from "./modal-add-product.vue?vue&type=style&index=0&id=6e23c989&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports